export default {
  filtersMap: {
    names: 'Grupos',
    themes: 'Temas',
    tags: 'Etiquetas',
    polarities: 'Sentimiento',
    dark_post: 'Tipo de Publicación',
    channels_listening: 'Canales',
    channels: 'Canales',
    uids: 'Autores',
    pages: 'Páginas',
    sac_type: 'Interacciones',
    sac_status: 'Estado',
    sac_replier: 'Respondientes',
    contracts: 'Contrato',
    bots: 'Bot',
    category: 'Categoría',
    domains: 'Canales',
    operators: 'Operadores',
    teams: 'Colas',
    desk_tags: 'Etiquetas',
    scheduled: 'Campañas',
    campaign_name: 'Nombre de la Campaña',
  },
  noRepliers: 'Sin respondientes',
  dateRange: 'Rango de tiempo',
  scheduledOnly: 'Solo Programadas',
};
